import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { TooltipProvider } from './components/ui/tooltip';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import Dashboard from './pages/Dashboard';
import ActivityDetail from './pages/ActivityDetail';
import ConnectOnboarding from './pages/ConnectOnboarding';
import Storefront from './pages/Storefront';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CoachesPage from './pages/CoachesPage';
import CoachDetailPage from './pages/CoachDetailPage';
import CoachingSuccess from './pages/CoachingSuccess';
import CoachingSkillsAdminPage from './pages/CoachingSkillsAdminPage';
import TrainingPlanDesignPage from './pages/TrainingPlanDesignPage';
import BlockCalendarPage from './pages/BlockCalendarPage';
import AttributeAnalyticsPage from './pages/AttributeAnalyticsPage';
import PeriodizationCatalogAdminPage from './pages/PeriodizationCatalogAdminPage';
import './utils/debugScreenshot';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <ThemeProvider>
          <LanguageProvider>
            <SettingsProvider>
              <TooltipProvider>
                <Routes>
                  <Route path='/' element={<HomePage />} />
                  <Route path='/features' element={<FeaturesPage />} />
                  <Route path='/login' element={<Navigate to='/login2' replace />} />
                  <Route path='/login2' element={<LoginPage />} />
                  <Route
                    element={
                      <ProtectedRoute>
                        <AppLayout />
                      </ProtectedRoute>
                    }
                  >
                    <Route path='dashboard' element={<Dashboard />} />
                    <Route path='activity/:id' element={<ActivityDetail />} />
                    <Route path='connect' element={<ConnectOnboarding />} />
                    <Route path='store' element={<Storefront />} />
                    <Route path='success' element={<CheckoutSuccess />} />
                    <Route path='coaches' element={<CoachesPage />} />
                    <Route path='coaches/:id' element={<CoachDetailPage />} />
                    <Route path='coaching/success' element={<CoachingSuccess />} />
                    <Route
                      path='health'
                      element={<Navigate to='/dashboard?context=athlete_health' replace />}
                    />
                    <Route path='admin/coaching-skills' element={<CoachingSkillsAdminPage />} />
                    <Route path='admin/periodization-catalog' element={<PeriodizationCatalogAdminPage />} />
                    <Route path='training-plan/design' element={<TrainingPlanDesignPage />} />
                    <Route path='training-plan/calendar' element={<BlockCalendarPage />} />
                    <Route path='training-plan/attribute-analytics' element={<AttributeAnalyticsPage />} />
                  </Route>
                  <Route path='*' element={<Navigate to='/' replace />} />
                </Routes>
              </TooltipProvider>
            </SettingsProvider>
          </LanguageProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
